import RichText from '@/components/content/common/RichText'

import { cn } from '@/lib/utils'
import type { Block } from '@/types/app'
import type { Blog } from '@/payload-types'

type BlogPostSummaryProps = {
  summary: Blog['summary']
  className?: string
}

export default function BlogPostSummary({ summary, className }: BlogPostSummaryProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-4 rounded-xl border border-gray-200 bg-gray-50 px-6 py-5 dark:border-zinc-800 dark:bg-white/5',
        className,
      )}
    >
      <h2 className="text-gray-950 dark:text-white">TLDR</h2>
      <RichText content={summary.root.children as Block[]} />
    </div>
  )
}
